import { createApiService } from './createApiService'

export const usersAPI = createApiService({
    reducerPath: 'usersAPI',
    tagTypes: ['User'],
    endpoints: (build: any) => ({
        changePassword: build.mutation({
            query: ({ currentPassword, newPassword }: { currentPassword: string; newPassword: string }) => ({
                url: '/users/change-password',
                method: 'POST',
                body: { currentPassword, newPassword },
            }),
            invalidatesTags: ['User'],
        }),
    }),
})

export const { 
    useChangePasswordMutation,
} = usersAPI